
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axiosInstance";

export const clientApi = createAsyncThunk("client", async ({ name = "", startDate = "", endDate = "" }) => {

  const params = {};

  // Add name to the query if provided
  if (name) {
    params.name = name;
  }

  // Add date range to the query if provided
  if (startDate) {
    params.startDate = startDate;
  }
  if (endDate) {
    params.endDate = endDate;
  }
  const response = await axiosInstance.get("/client",{
    params, // Pass the parameters to the API request
  });
  return response.data;
});

const clientSlice = createSlice({
  name: "client",
  initialState: {
    client: [],
    errors: [],
    loading: false,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(clientApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(clientApi.fulfilled, (state, action) => {
        state.client = action.payload;
        state.loading = false;
      })
      .addCase(clientApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.loading = false;
      });
  },
});

export default clientSlice.reducer;
